<template>
    <div class="corporatecommunity">
<!--        <spinner class="pink" v-model="toggleSpinner" v-if="toggleSpinner" size="lg" fixed text="refreshing event"></spinner>-->
        <div class="container" v-if="associatedCorporation">
            <div class="row">
                <div class="col-md-2">
                    <div class="smallimgholder">
                        <img v-if="associatedCorporation.smallImage" :src="associatedCorporation.smallImage" alt="CORP IMAGE" :title="associatedCorporation.name"/><div class="hidemobile"><br /> <b> {{associatedCorporation.pageWelcomeMessage}}</b>
                       <br /><br />
                        <img src="../assets/toneApp.png" alt="APP QR CODE" text="APP QR Code"/><br /> {{associatedCorporation.pageWelcomeMessage}}Scan the QR code to download our app and enjoy Tone on the go!
                    </div></div>

                </div>
                <div class="col-md-10 margin-bottom-40">
                        <div class="tabs">
                            <ul>
                                <li v-if="associatedCorporation.showSpotlightSection || associatedCorporation.showPinnedMessages" @click="switchTab('community')" :class="{ current: selectedTab === 'community' }" class="community"><a href="javascript:">Community</a></li>
                                <li @click="switchTab('events')" :class="{ current: selectedTab === 'events' }" class="events"><a href="javascript:"><span class="hidemobile">Career</span> Coaching</a></li>
                                <li v-if= "getCorpPrivateVideos" @click="switchTab('videos')" :class="{ current: selectedTab === 'videos' }" class="events"><a href="javascript:"> Videos</a></li>
                                <li v-if="getCorpPlaylists" @click="switchTab('playlists')" :class="{ current: selectedTab === 'playlists' }" class="playlists"><a href="javascript:">Playlists</a></li>
                            </ul>
                        </div>
                        <div v-if="selectedTab === 'community'" class="tabContent" id="tabs-1" :class="{ current: tabs.community }">
                            <div class="row video-row introparacard" v-if="associatedCorporation.showSpotlightSection">
                                <div class="clearfix"></div>
                                    <div class="col-sm-3" v-if="associatedCorporation.spotlightPic">
                                        <img :src="associatedCorporation.spotlightPic" alt="SPOTLIGHT IMAGE" title="In Spotlight" />
                                    </div>
                                <br>
                                    <div class="col-sm-9">
                                        <p v-if="associatedCorporation.spotlightPara1" v-html="associatedCorporation.spotlightPara1"></p>
                                        <p v-if="associatedCorporation.spotlightPara2" v-html="associatedCorporation.spotlightPara2"></p>
                                        <p v-if="associatedCorporation.spotlightPara3" v-html="associatedCorporation.spotlightPara3"></p>
                                    </div>
                                    <div class="clearfix"></div>
                                <div class="col-sm-12">
                                    <blockquote v-if="associatedCorporation.spotlightQuote">"{{associatedCorporation.spotlightQuote}}"</blockquote>
                                    <div class="clearfix"></div>
                                    <hr class="redhr" />
                                </div>

                            </div>
                            <div class="pinnedmsgs" v-if="getCorporationPinnedMsgs && (associatedCorporation.showPinnedMessages || associatedCorporation.showPinnedMessages === 1)">
                                <h3 v-if="associatedCorporation.pinnedMessageHeading">{{associatedCorporation.pinnedMessageHeading}}&nbsp;<i class="fa fa-map-pin "></i></h3>
                                <div class="clearfix"></div>
                                <div class="borderedbox" v-for="msg in getCorporationPinnedMsgs">
                                    <h4>{{msg.msgSenderName}} <small>{{msg.msgSentDateFmt}}</small></h4>
                                    <p>{{msg.corpAdminMessage}}</p>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </div>
                        <div v-if="selectedTab === 'events'" class="tabContent" id="tabs-2" :class="{ current: tabs.events }">
                            <div class="row video-row" v-if="getCorpMainEvent">
                                <h3><b>Join {{associatedCorporation.name}} and TONE Networks for Event this {{getDateReference(getCorpMainEvent.start_date, 'str')}}</b></h3>
                                <div class="clearfix"></div>
                                <div class="col-md-12 pinkbordercomp">
                                    <div>
                                        <h3>Choose how you want to join the event. You can join as yourself or step into someone else's shoes using our anonymous shoe-cognito mode</h3>
                                        <br><br>
                                        <button type="button" @click="generateUnAuthTokenAndRedirect('0')" title="Join event">Jane</button>
                                        <button type="button" @click="generateUnAuthTokenAndRedirect('1')" title="Join event">Shoe-Incognito</button>
                                        <div>
                                            Please follow the event guidelines:
                                            <span>1.)</span> Keep it positive, supportive and respectful;
                                            <span>2.)</span> Please be thoughtful and stay on topic;
                                            <span>3.)</span> Please do not post copyrighted material, ads, solicitations or anyone's personal info including your own;
                                            <span>4.)</span> Please refer to TONE's <a href="/terms" target="new" title="click to view our terms">Terms of Service</a> for more information.
                                        </div>
                                        <!--<button type="button" @click="joinEvent('1')" title="Join event as shoe-cognito">Shoe-cognito</button>-->
                                    </div>

                                </div>
                                <div class="clearfix" style="height:30px"></div>
                                <div class="col-sm-6 imgresponsive"><img :src="getCorpMainEvent.img_url" alt="CORP MAIN EVENT BANENR" :title="getCorpMainEvent.title"></div>
                                <div class="col-sm-6 text-left large-text">
                                    <h3>{{getCorpMainEvent.title}}</h3>
                                    <p>{{getCorpMainEvent.longDescription}}</p>
                                    <br>
                                    <br><br>
                                    <p>{{getDateReference(getCorpMainEvent.start_date, 'str')}}</p>
<!--                                    <div title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(getCorpMainEvent.eventId)">-->
<!--                                        Add to Calendar-->
<!--                                        <span class="start">{{getCorpMainEvent.start_date}}</span>-->
<!--                                        <span class="end">{{getCorpMainEvent.end_date}}</span>-->
<!--                                        <span class="timezone">America/New_York</span>-->
<!--                                        <span class="title">{{getCorpMainEvent.title}}</span>-->
<!--                                        <span class="description">{{getCorpMainEvent.longDescription}}</span>-->
<!--                                        <span class="location">-->
<!--                                            <span v-if="getCorpMainEvent.isPrivate === 1">-->
<!--                                            <span v-if="getCorpMainEvent.type === '1'">{{privateEventURL}}</span>-->
<!--                                         <span v-if="getCorpMainEvent.type === '2'">{{privateEventURL}}</span>-->
<!--                                            <span v-if="getCorpMainEvent.type === '3'">{{associatedCorporation.name}}'s Self-Hosted Event</span>-->
<!--                                            </span>-->
<!--                                            <span v-else>-->
<!--                                                <span v-if="getCorpMainEvent.type === '1'">{{eventURL}}/event/{{getCorpMainEvent.eventId}}</span>-->
<!--                                            <span v-if="getCorpMainEvent.type === '2'">{{eventURL}}/event/{{getCorpMainEvent.eventId}}</span>-->
<!--                                            <span v-if="getCorpMainEvent.type === '3'">{{associatedCorporation.name}}'s Self-Hosted Event</span>-->
<!--                                            </span>-->
<!--                                        </span>-->
<!--                                    </div>-->
                                </div>
<!--                                <div class="col-md-12 pinkbordercomp" v-if="getCorpMainEvent && getCorpMainEvent.type !== '3' && !showJoin(getCorpMainEvent.eventId)" >-->
<!--                                    <rulescomp v-if="getCorpMainEvent" :data="getCorpMainEvent">Loading event rules</rulescomp>-->
<!--                                </div>-->
                            </div>
                            <div class="clearfix" style="height:50px"></div>
                            <div class="row" v-if="getCorpPrivateEvents && getCorpPrivateEvents.length >= 2">
                                <h3>
                                    <b>
                                        <h3 v-if="associatedCorporation.privateEventHeading"><b>{{associatedCorporation.privateEventHeading}}</b></h3>
                                    </b>
                                </h3>
                                <div class="col-sm-6 imgresponsive large-text text-left">
                                    <div class="clearfix" style="height:30px"></div>
                                    <img :src="getCorpPrivateEvents[0].img_url" alt="PRIVATE EVENT BANNER" :title="getCorpPrivateEvents[0].title">
                                    <div class="clearfix"></div>
                                    <h3>{{getCorpPrivateEvents[0].title}}</h3>
                                    <p>{{getCorpPrivateEvents[0].longDescription}}</p>
                                    <br><br>
                                    <p>{{getDateReference(getCorpPrivateEvents[0].start_date, 'str')}}</p>
                                    <br>
                                    <div title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(getCorpPrivateEvents[0].eventId)">
                                        Add to Calendar
                                        <span class="start">{{getCorpPrivateEvents[0].start_date}}</span>
                                        <span class="end">{{getCorpPrivateEvents[0].end_date}}</span>
                                        <span class="timezone">America/New_York</span>
                                        <span class="title">{{getCorpPrivateEvents[0].title}}</span>
                                        <span class="description">{{getCorpPrivateEvents[0].longDescription}}</span>
                                        <!--<span class="location"><span v-if="getCorpPrivateEvents[0].type === '1'">{{eventURL}}/event/{{getCorpPrivateEvents[0].eventId}}</span><span v-else>{{eventURL}}/event/{{getCorpPrivateEvents[0].eventId}}</span></span>-->
                                        <span class="location">
                                            <span v-if="getCorpPrivateEvents[0].type === '1'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[0].type === '2'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[0].type === '3'">{{associatedCorporation.name}}'s Self-Hosted Event</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="col-sm-6 imgresponsive large-text text-left">
                                    <div class="clearfix" style="height:30px"></div>
                                    <img :src="getCorpPrivateEvents[1].img_url" alt="PRIVATE EVENT BANNER" :title="getCorpPrivateEvents[1].title">
                                    <div class="clearfix"></div>
                                    <h3>{{getCorpPrivateEvents[1].title}}</h3>
                                    <p>{{getCorpPrivateEvents[1].longDescription}}</p>
                                    <br><br>
                                    <p>{{getDateReference(getCorpPrivateEvents[1].start_date, 'str')}}</p>
                                    <br>
                                    <div title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(getCorpPrivateEvents[1].eventId)">
                                        Add to Calendar
                                        <span class="start">{{getCorpPrivateEvents[1].start_date}}</span>
                                        <span class="end">{{getCorpPrivateEvents[1].end_date}}</span>
                                        <span class="timezone">America/New_York</span>
                                        <span class="title">{{getCorpPrivateEvents[1].title}}</span>
                                        <span class="description">{{getCorpPrivateEvents[1].longDescription}}</span>
                                        <!--<span class="location"><span v-if="getCorpPrivateEvents[1].type === '1'">{{eventURL}}/event/{{getCorpPrivateEvents[1].eventId}}</span><span v-else>{{eventURL}}/event/{{getCorpPrivateEvents[1].eventId}}</span></span>-->
                                        <span class="location">
                                            <span v-if="getCorpPrivateEvents[0].type === '1'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[0].type === '2'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[1].type === '3'">{{associatedCorporation.name}}'s Self-Hosted Event</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="row" v-if="getCorpPrivateEvents && getCorpPrivateEvents.length === 1">
                                <h3>
                                    <b>
                                        <h3 v-if="associatedCorporation.privateEventHeading"><b>{{associatedCorporation.privateEventHeading}}</b></h3>
                                    </b>
                                </h3>
                                <div class="col-sm-6 m-auto imgresponsive large-text text-left">
                                    <div class="clearfix" style="height:30px"></div>
                                    <img :src="getCorpPrivateEvents[0].img_url" alt="PRIVATE EVENT BANNER" :title="getCorpPrivateEvents[0].title">
                                    <div class="clearfix"></div>
                                    <h3>{{getCorpPrivateEvents[0].title}}</h3>
                                    <p>{{getCorpPrivateEvents[0].longDescription}}</p>
                                    <br><br>
                                    <p>{{getDateReference(getCorpPrivateEvents[0].start_date, 'str')}}</p>
                                    <br>
                                    <div title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(getCorpPrivateEvents[0].eventId)">
                                        Add to Calendar
                                        <span class="start">{{getCorpPrivateEvents[0].start_date}}</span>
                                        <span class="end">{{getCorpPrivateEvents[0].end_date}}</span>
                                        <span class="timezone">America/New_York</span>
                                        <span class="title">{{getCorpPrivateEvents[0].title}}</span>
                                        <span class="description">{{getCorpPrivateEvents[0].longDescription}}</span>
                                        <span class="location">
                                            <span v-if="getCorpPrivateEvents[0].type === '1'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[0].type === '2'">{{privateEventURL}}</span>
                                            <span v-if="getCorpPrivateEvents[0].type === '3'">{{associatedCorporation.name}}'s Self-Hosted Event</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="clearfix" style="height: 50px;border-bottom: 3px solid #cbcbcb;margin-bottom: 30px;"></div>
                            <div class="sliderEventBox" v-if="getCorpPublicEvents">
                                <h2 v-if="associatedCorporation.toneEventHeading">{{associatedCorporation.toneEventHeading}}</h2>
                                <div class="slider responsive-slick-slider">
                                    <div class="col-sm-4" v-for="ev in getCorpPublicEvents">
                                        <h2 class="carosalh2" style="color: #f0617d"><span v-if="ev.type === '1'"> TONE Live
</span><span v-else> TONE Talk</span></h2>
                                        <img v-bind:src="ev.img_url" class="sliderimage" alt="PUBLIC EVENT BANNER" :title="ev.title" />
                                        <!--<img v-bind:src="getExpertInfo(ev.expertId, 'img')" />-->
                                        <h2><a :href="'/event/' + ev.eventId" target="new">{{getDateReference(ev.start_date, 'live')}}:  {{getExpertInfo(ev.expertId, 'name')}}</a></h2>
                                        <p>
                                            {{ev.longDescription}}
                                        </p>
                                        <h5>LIVE {{getDateReference(ev.start_date, 'live2')}}</h5>
                                        <!--time left in event {{timeLeftInEvent(ev.start_date)}}-->
                                        <!--<button class="button" type="button" v-if="isUserEntrolled(ev.eventId) && isEventToday(ev.start_date, ev.end_date, ev.eventSwitchTime, getEventSwitchTime) === false"><i class="fa 2x fa-check" aria-hidden="true"></i>&nbsp;Reserved&nbsp;</button>-->
                                        <div title="Add to Calendar" class="addeventatc pinkoutlinebtn" v-if="!showJoin(ev.eventId)">
                                            Add to Calendar
                                            <span class="start">{{ev.start_date}}</span>
                                            <span class="end">{{ev.end_date}}</span>
                                            <span class="timezone">ev/New_York</span>
                                            <span class="title">{{ev.title}}</span>
                                            <span class="description">{{ev.longDescription}}</span>
                                            <span class="location">{{eventURL}}/event/{{ev.eventId}}</span>
                                        </div>
                                        <!--<button  class="button" type="button" v-if="showJoin(ev.eventId)" @click="joinEvent(ev)"><i class="fa 2x fa-arrow-circle-right" aria-hidden="true"></i>&nbsp;Go to Event&nbsp;</button>-->
                                        <!--<button v-if="!isUserEntrolled(ev.eventId) && isEventToday(ev.start_date, ev.end_date) === false" @click="enrollUser(ev)" class="button">Reserve your spot</button>-->
                                    </div>
                                </div>
                                <div v-if="getCorpArchiveEvents" class="clearfix" style="height: 50px;border-bottom: 3px solid #cbcbcb;margin-bottom: 30px;"></div>
                                <div class="col-sm-12" v-if="getCorpArchiveEvents">
                                    <h3 v-if="associatedCorporation.archiveEventHeading"><strong>{{associatedCorporation.archiveEventHeading}}</strong></h3>
                                    <div class="clearfix" style="height:30px;"></div>
                                </div>
                                <div class="clearfix" v-if="getCorpArchiveEvents"></div>
                                <div class="sliderEventBox pointer" v-if="getCorpArchiveEvents">
                                    <div class="slider responsive-slick-slider">
                                        <div class="col-sm-4" v-for="evn in getCorpArchiveEvents" style="cursor: pointer">
                                            <img v-bind:src="evn.img_url" class="sliderimage" @click="playVideoArchive(evn.eventId, evn.title)" alt="PRIVATE EVENT BANNER" :title="evn.title" />
                                            <h2 @click="playVideoArchive(evn.eventId, evn.title)">{{evn.title}}</h2>
                                            <p @click="playVideoArchive(evn.eventId, evn.title)">
                                                {{evn.longDescription}}

                                            </p>
                                            <!--<button class="button" type="button" @click="playVideoArchive(evn.eventId, evn.title)"><i class="fa 2x fa-play-circle-o" aria-hidden="true"></i>&nbsp;Play&nbsp;</button>-->
                                            <!--<h5>{{getDateReference(evn.start_date, 'live2')}}</h5>-->
                                            <!--time left in event {{timeLeftInEvent(evn.start_date)}}-->
                                            <!--<span>72 Members | 302 Comments</span>-->
                                            <!--<button class="button" v-if="!isUserEntrolled(evn.eventId) && isEventToday(evn.start_date, evn.end_date) === false" @click="enrollUser(evn)" type="button">Reserve your spot</button>-->
                                            <!--<button  class="btn btn-danger expert-section-btn btn-transparent">Reserve a Seat at the Table</button>-->
                                            <!--<button type="button" class="btn disabled">Coming Soon</button>-->
                                        </div>
                                    </div>
                                </div>
                                <!--<div class="col-sm-6 incaseumi">-->
                                    <!--<img src="https://s3.amazonaws.com/tone-assets/images/events/ToneTues2.png" />-->
                                    <!--<h3>Video Title</h3>-->
                                    <!--<p>Lorium ispm dollar sit amitLorium ispm dollar sit amitLorium ispm dollar sit amit</p>-->
                                <!--</div>-->
                                <!--<div class="col-sm-6 incaseumi">-->
                                    <!--<img src="https://s3.amazonaws.com/tone-assets/images/events/ToneTues2.png" />-->
                                    <!--<h3>Video Title</h3>-->
                                    <!--<p>Lorium ispm dollar sit amitLorium ispm dollar sit amitLorium ispm dollar sit amit</p>-->
                                <!--</div>-->
                                <div class="clearfix" style="height:50px;border-bottom:1px solid #ddd;"></div>
                            </div>
                        </div>
                         <div v-if="selectedTab === 'videos'" class="tabContent" id="tabs-3" :class="{ current: tabs.videos }">
                             <h3 v-if="associatedCorporation.videoTabHeading"><b>{{associatedCorporation.videoTabHeading}}</b></h3>
                                 <div class="row yourFaves" v-if="getCorpPrivateVideos">
                                     <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin"  v-for = "video in getCorpPrivateVideos">
                                         <a :href="'/watch/' + video.mediaid + '/' + video.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                             <img class="jw-img" :src="video.image"  :alt="video.title" :title="video.title" />
                                             <p class="text-wrap-title cursor" >
                                                 <i class="fa fa-play-circle-o"></i>
                                                 {{video.title}}
                                             </p>
                                         </a>
                                     </div>
                                 </div>
                    </div>
                         <div v-if="selectedTab === 'playlists'" class="tabContent" id="tabs-4" :class="{ current: tabs.playlists }">
                        <div class="row video-row plistisrow" v-if="getCorpPlaylists" >
                            <div class="col-sm-12">
                            <h2 v-if="associatedCorporation.playlistHeading">{{associatedCorporation.playlistHeading}}</h2>
                            <div class="clearfix" style="height:30px;"></div>
                            </div>
                            <div v-for="playlist in getCorpPlaylists" v-if="playlist.userPlaylistVideos">
                                <div class="clearfix"></div>
                                <div class="col-sm-6 ">
                                    <div class="pinkbg" v-if="playlist.userPlaylistVideos && playlist.userPlaylistVideos.length > 0">
                                        <img style="cursor: pointer" :src="playlist.userPlaylistVideos[0].thumbnailURL"  :alt="playlist.title" :title="playlist.title"/>
                                        <div class="pinksidebarmin">
                                            <span class="numb"><strong>{{playlist.userPlaylistVideos.length}}</strong></span>
                                            <i class="fa fa-play-circle-o"></i>
                                            <i title="Share Playlist" class="fa fa-envelope-o" @click="openCorporateShareModal(playlist)"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6 pltext">
                                    <h3 @click="playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)">{{playlist.title}}</h3>
                                    <br>
                                    <p><strong>{{playlist.description}}</strong></p>
                                </div>
                                <div class="clearfix" style="height:10px"></div>

                                    </div>
                            <div class="col-sm-12" v-if="getCropUserSharedVideos">
                                    <hr style="height: 50px;">
                                    <h3>Here are all videos shared with you by your colleagues</h3>
                                    <div class="clearfix" style="height: 50px;"></div>
                                </div>
<div class="clearfix"></div>
                        </div>
                            <div class="row  video-row plistisrow lowerlist">
                                <div class="col-sm-6" v-for="video in getCropUserSharedVideos">
                                    <div class="videoholdersuggestions">
                                        <img :src="video.thumbnailURL" @click="setVideoPlayerObject(video.videoCode)" :alt="video.videoTitle" :title="video.videoTitle" />
                                        <h3  @click="setVideoPlayerObject(video.videoCode)">{{video.videoTitle}}</h3>
                                        <p>Shared by {{video.senderName}}</p>
                                        <p>Message: {{video.messageText}}</p>
                                    </div>
                                </div>

                                <!--<div class="col-sm-6">-->
                                    <!--<div class="videoholdersuggestions">-->
                                        <!--<img src="https://cdn.jwplayer.com/thumbs/XC9MzmHV-720.jpg" />-->
                                        <!--<h3>Video Title here</h3>-->
                                        <!--<p>lorium ispm secondline</p>-->
                                        <!--<p>lorium ispm dollar sit amit lorium ispm dollar sit amit lorium ispm dollar sit amit lorium ispm dollar sit amit lorium ispm dollar sit amit lorium ispm dollar sit amit lorium ispm dollar sit amit </p>-->
                                    <!--</div>-->
                                <!--</div>-->
                        </div>
                    </div>
                    </div>

                </div>
            </div>
        <modal v-if="showCorporateShare" class="watchVideoModal sharesmallpink" effect="zoom" :value="showCorporateShare" @cancel="cancelCorporateModal()">
            <div slot="modal-header" class="watchVideoModalHeader">
                <i class="fa fa-share-square-o"></i> Share This Playlist
                <a href="javascript:" @click="cancelCorporateModal()">
                    <img class="watchVideoArrow" src="../assets/watch-video-arrow.png" alt="CLOSE">
                </a>
            </div>
            <div slot="modal-body" class="modal-body">
                <div class="row">
                    <div class="col-sm-4">
                        <select v-model="shareOption" class="form-control strongselec">
                            <option value="Corporate">Share with Community</option>
                            <option value="Individual">Share with Colleagues</option>
                        </select>
                    </div>
                    <div class="col-sm-12"  v-if="shareOption === 'Individual'">
                        <div class="clearfix" style="height: 20px;"></div>
                        <multiselect v-if="shareOption === 'Individual'"
                                     v-model="selectedCorps"
                                     :options="allCorps"
                                     :multiple="true"
                                     :taggable="true"
                                     track-by="userId"
                                     :custom-label="customLabel">
                        </multiselect>
                    </div>
                </div>
                <hr>
                <div class="usernamenimg text-left">
                    <table>
                        <tr>
                            <td>
                                <img src="https://s3.amazonaws.com/assets.tonenetworks.com/images/profile-pictures/small-imgs/shoes_red_flat.jpg" alt="user-shoe">
                            </td>
                            <td>
                                <b>Jane</b>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="clearfix"></div>
                <textarea v-model="corporateShareMessage"
                          type="textarea"
                          class="form-input form-control"
                          placeholder="Type your message"
                />
                <div class="clearfix" style="height: 30px;"></div>
                <div class="row sharefb">
                    <div class="col-sm-5 col-xs-5">
                        <img :src="corpShareModalImage" :alt="corpShareModalTitle" :title="corpShareModalTitle">
                    </div>
                    <div class="col-sm-7 col-xs-7">
                        <h6>WWW.TONENETWORKS.COM</h6>
                        <h4>{{`${corpShareModalTitle} | TONE Networks`}}</h4>
                        <p> {{`${corpShareModalDesc.substring(0,250)}...`}}</p>
                    </div>
                </div>
                <div class="row buttonsinpopup">
                    <div class="col-sm-3 col-xs-4">
                        <button class="btn btn-default" @click="cancelCorporateModal()">
                            Cancel
                        </button>
                    </div>
                    <div class="col-sm-9 col-xs-8">
                        <button class="btn btn-primary btn-pink" :disabled="shareOption === 'Individual' && (selectedCorps === null || selectedCorps.length === 0)" @click="shareCorporateVideo()">
                            Share This Playlist
                            <spinner v-model="spinner" size="lg" class="btn-spinner"></spinner>
                        </button>
                    </div>
                </div>
                <div class="alert alert-default showmobile">
                    You are sharing as Jane
                </div>
            </div>
            <div slot="modal-footer"></div>
        </modal>
        </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {spinner, alert, modal} from 'vue-strap'
// import store from '../store'
import $ from 'jquery'
import { dateHelpers } from '../helpers/dateHelpers.js'
import rulescomp from './RulesComp.vue'
import slick from 'slick-carousel'
export default {
    components: {
        spinner: spinner,
        alert: alert,
        rulescomp,
        modal
    },
    name: 'corporatecommunity',
    metaInfo () {
        return {
            title: 'TONE | Community',
            meta: [
                {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                {property: 'og:title', content: 'TONE | Community'},
                {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                {
                    property: 'og:description',
                    content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                },
                {property: 'twitter:title', content: 'TONE | Community'},
                {property: 'twitter:card', content: 'summary'},
                {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                {
                    property: 'twitter:description',
                    content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                },
                {property: 'og:image:width', content: '300'},
                {property: 'og:image:height', content: '300'}
            ]
        }
    },
    data: function () {
        return {
            toggleSpinner: false,
            contentToSearch: '',
            privateEventURL: window.location.href,
            pageLimit: 6,
            pageStart: 1,
            pageEnd: 6,
            enteredValue: '',
            spinner: false,
            isBlankField: false,
            isEmptyResponse: false,
            currentPlan: '',
            signUpPath: '',
            tabs: {
                community: false,
                events: false,
                playlists: false,
                videos: false
            },
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            isNativeApp: false,
            showCorporateShare: false,
            selectedCorps: null,
            corporateShareMessage: '',
            selectedTab: '',
            shareOption: 'Corporate',
            topImage: 'https://s3.amazonaws.com/tone-assets/images/resources/GettyImages-863497498-min.jpg',
            smallImage: 'https://s3.amazonaws.com/tone-assets/images/resources/4th-of-july-blur-bokeh-450301.jpg',
            spotlightImage: 'https://s3.amazonaws.com/tone-assets-prod/images/team/Pippa-Schwarzkopf-Editor.png',
            eventURL: 'https://www1.dev-tonenetworks.com',
            corpShareModalImage: '',
            corpShareModalDesc: '',
            corpShareModalTitle: '',
            corporateInfo: null,
            selectedPlaylist: null,
            associatedCorporation: null,
            shareVideoPayload: {
                corporationId: 0,
                senderUserId: 0,
                recipientsUserIds: [],
                playlistId: '',
                messageText: ''
            }
        }
    },
    mounted () {
        console.info('inside page')
        let self = this
        self.$store.dispatch('GETDEMOEVENTS').then(() => {
            if (self.getDemoEvent && self.getDemoEvent.demoCorporationId > 1) {
                console.log('demo event', self.getDemoEvent)
                self.$store.dispatch('GETCORPORATECLIENTFORDEMO', self.getDemoEvent.demoCorporationId).then(() => {
                    console.log('corporation reference', self.getCorporateClientForDemo)
                    if (self.getCorporateClientForDemo && self.getCorporateClientForDemo.corporationId > 0) {
                        console.log('de')
                        self.associatedCorporation = self.getCorporateClientForDemo
                        console.info('corporation reference', self.getCorporateClientForDemo)
                        this.$store.dispatch('GETALLEXPERTS').then(() => {
                        })
                        this.$store.dispatch('GETCORPEVENTS', self.associatedCorporation.corporationId).then(() => {
                            if (this.getCorpAllEvents) {
                                this.calculateTimeToStartEvent(this.getCorpMainEvent.start_date, this.getCorpMainEvent.end_date, this.getCorpMainEvent.eventSwitchTime, this.getEventSwitchTime)
                                // console.log('all events fetched', this.getCorpAllEvents)
                                // console.log('all public events', this.getCorpPublicEvents)
                                // console.log('all private events', this.getCorpPrivateEvents)
                                // console.log('main event', this.getCorpMainEvent)
                            }
                        })
                        this.$store.dispatch('GETCORPEVENTSARCHIVE', self.associatedCorporation.corporationId).then(() => {
                            if (this.getCorpArchiveEvents) {
//                console.log('archive events', this.getCorpArchiveEvents)
                            }
                        })
                        this.$store.dispatch('GETCORPPRIVATEVIDEOS', self.associatedCorporation.corporationId).then(() => {
                            if (this.getCorpPrivateVideos) {
//                console.log('archive events', this.getCorpArchiveEvents)
                            }
                        })
                        this.$store.dispatch('GETCORPORATIONPINNEDMSGS', self.associatedCorporation.corporationId).then(() => {
                            if (this.getCorporationPinnedMsgs) {
//                console.log('corp Pinned Msgs', this.getCorporationPinnedMsgs)
                            }
                        })
                        this.$store.dispatch('GETCORPPLAYLISTS', self.associatedCorporation.corporationId).then(() => {
                            if (this.getCorpPlaylists) {
                                // console.log('corp Playlists', this.getCorpPlaylists)
                            }
                        })
                        this.$store.dispatch('GETCORPSHAREDVIDEOS', this.user.userId).then(() => {
                            if (this.getCropUserSharedVideos) {
//                console.log('corp shared videos', this.getCropUserSharedVideos)
                            }
                        })
                        // Get Corporatin Payload if user is part of corporation
                        this.$store.dispatch('GETCORPPAYLOAD', this.user.userId).then(() => {
                            this.allCorps = []
                            if (this.getCorporatePayload) {
                                this.corporateInfo = this.getCorporatePayload
                                this.allCorps = this.corporateInfo.lstCorporationUsers
                            }
                        })
                        self.selectedTab = 'events'
                        // if (this.$route.params.tab) {
                        //     console.log('selected tab', this.$route.params.tab)
                        //     setTimeout(() => {
                        //         let tab = this.$route.params.tab
                        //         if (tab === 'career') {
                        //             this.selectedTab = 'events'
                        //         } else if (tab === 'playlists') {
                        //             console.info('inside playlists')
                        //             if (this.getCorpPlaylists) {
                        //                 this.selectedTab = 'playlists'
                        //                 console.log('playlist set')
                        //             } else {
                        //                 this.selectedTab = 'events'
                        //             }
                        //         } else if (tab === 'videos') {
                        //             if (this.getCorpPrivateVideos) {
                        //                 this.selectedTab = 'videos'
                        //             } else {
                        //                 this.selectedTab = 'events'
                        //             }
                        //         } else if (tab === 'community') {
                        //             if (self.associatedCorporation.showSpotlightSection || self.associatedCorporation.showPinnedMessages) {
                        //                 this.selectedTab = 'community'
                        //             } else {
                        //                 this.selectedTab = 'events'
                        //             }
                        //         } else {
                        //             this.selectedTab = 'events'
                        //         }
                        //     }, 800)
                        // }
                    } else {
                        console.info(2)
                        self.$router.push('/')
                    }
                })
            } else {
                console.info(1)
                self.$router.push('/')
            }
        })
        self.selectedTab = 'events'
    },
    watch: {
        'showCorporateShare' (to, from) {
            let self = this
            if (self.showCorporateShare) {
                self.selectedCorps = null
                self.corporateShareMessage = ''
                self.shareOption = 'Corporate'
            }
        },
        'selectedTab' (to, from) {
            if (this.selectedTab === 'events') {
                setTimeout(() => {
                    this.createCarousal()
                }, 2000)
                setTimeout(function () {
                    window.addeventatc.refresh()
                }, 2500)
            }
        },
        'shareOption' (to, from) {
            let self = this
            self.selectedCorps = null
            self.corporateShareMessage = ''
//            self.corpShareModalImage = ''
//            self.corpShareModalDesc = ''
//            self.corpShareModalTitle = ''
        }
    },
    methods: {
        generateUnAuthTokenAndRedirect (status) {
            this.$store.dispatch('GENERATE_UNAUTH_SIGNATURE', status).then(() => {
                if (this.getUnauthUserSignature) {
                    this.$router.push(`/tone/demo/live-event-demo/${this.getCorpMainEvent.eventId}`)
                }
            })
        },
        maskEmailAddress (userEmail) {
            let avg, splitted, part1, part2
            splitted = userEmail.split('@')
            part1 = splitted[0]
            let regex = /[^0-9.]/g
            let maskid = part1.substring(0, 1) + part1.replace(regex, '*').substring(1)
            console.log('maked', maskid)
            avg = part1.length / 2
            part1 = part1.substring(0, (part1.length - avg))
            part2 = splitted[1]
            let maskDomain = part2.split('.')
            return maskid + '@' + maskDomain[0].replace(regex, '*') + '.' + maskDomain[maskDomain.length - 1]
        },
        openCorporateShareModal (playlistObj) {
            console.info('called')
            let self = this
            self.corpShareModalImage = playlistObj.userPlaylistVideos[0].thumbnailURL
            self.corpShareModalDesc = playlistObj.description
            self.corpShareModalTitle = playlistObj.title
            self.selectedPlaylist = playlistObj
            self.showCorporateShare = true
        },
        shareCorporateVideo () {
            let self = this
            self.spinnerToggle()
            self.cancelCorporateModal()
            self.$swal({
                title: 'Playlist has been shared!',
                text: '',
                type: 'success',
                timer: 3000,
                showCancelButton: false,
                showConfirmButton: false
            }).then(
                function () {
                },
                // handling the promise rejection
                function (dismiss) {
                    if (dismiss === 'timer') {
                        self.spinnerToggle()
                        // self.cancelCorporateModal()
                    }
                }
            )
            // self.shareVideoPayload.corporationId = self.shareOption === 'Corporate' ? 1 : 0
            // self.shareVideoPayload.senderUserId = self.user.userId
            // self.shareVideoPayload.recipientsUserIds = []
            // self.shareVideoPayload.messageText = self.corporateShareMessage
            // if (self.shareVideoPayload.corporationId !== 1) { // Being sent to individuals
            //     if (self.selectedCorps && self.selectedCorps.length > 0) {
            //         self.shareVideoPayload.recipientsUserIds = self.selectedCorps.map(x => {
            //             return x.userId
            //         })
            //     }
            // }
            // self.shareVideoPayload.playlistId = self.selectedPlaylist.playlistId
            // // Send the Email
            // self.$store.dispatch('PLAYLISTCORPORATESHARE', {payload: self.shareVideoPayload}).then(() => {
            //     if (!self.error.show) {
            //         self.spinnerToggle()
            //         self.$swal({
            //             title: 'Playlist has been shared!',
            //             text: '',
            //             type: 'success',
            //             timer: 3000,
            //             showCancelButton: false,
            //             showConfirmButton: false
            //         }).then(
            //             function () {
            //             },
            //             // handling the promise rejection
            //             function (dismiss) {
            //                 if (dismiss === 'timer') {
            //                 }
            //             }
            //         )
            //         self.spinnerToggle()
            //         self.cancelCorporateModal()
            //     } else {
            //         self.spinnerToggle()
            //         self.cancelCorporateModal()
            //     }
            // })
        },
        customLabel (option) {
            let findDuplicate = this.allCorps.find(x => {
                return x.firstName.toLowerCase() === option.firstName.toLowerCase() && x.lastName.toLowerCase() === option.lastName.toLowerCase() && x.userId !== option.userId
            })
//            console.log('findDuplicate', findDuplicate)
            if (findDuplicate) {
                let maskedEmail = this.maskEmailAddress(option.email)
                return `${option.firstName} ${option.lastName} <${maskedEmail}>`
            } else {
                return `${option.firstName} ${option.lastName}`
            }
        },
        cancelCorporateModal () {
            $('html').removeClass('model-open')
            var self = this
            window.setTimeout(function () {
                self.showCorporateShare = false
                $('.modal-open').removeClass('modal-open')
            }, 500)
        },
        getMinutesBetweenDates (startDate, endDate) {
            var diff = endDate.getTime() - startDate.getTime()
            return (diff / 60000)
        },
        setVideoPlayerObject (videoCode) {
            this.$router.push(`/watch/${videoCode}`)
        },
        playPlaylist (playlistId, videoCode, playlistTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push(`/becomemember`)
            } else {
                this.$router.push(`/playlist/${playlistId}/play/${videoCode}/${this.associatedCorporation.corporationId}/${playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
            }
        },
        playVideoArchive (eventId, eventTitle) {
            this.$router.push(`/tonearchive/${eventId}/play/1/${eventTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
            location.reload()
        },
        createCarousal () {
            $.slick = slick
            const $slick = $(this.$el).find('.responsive-slick-slider')
            $slick.slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow: 3,
                slidesToScroll: 1,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                }, {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }, {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            })
        },
        getExpertInfo (expertId, info) {
            let reqInfo
            if (this.getAllExperts) {
                let expert = this.getAllExperts.filter(exp => {
                    return exp.expertId === expertId
                })
                if (info === 'name') {
                    reqInfo = expert[0].name
                } else if (info === 'img') {
                    reqInfo = expert[0].small_image
                } else if (info === 'biography') {
                    reqInfo = expert[0].biography
                } else if (info === 'experties') {
                    reqInfo = expert[0].experties
                }
            }
            return reqInfo
        },
        isEventToday (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            // console.log('1st switch time', defaultSwitchTime)
            let eventDate = new Date(evtDate)
            let eventEndDate = new Date(endDate)
            let currentDate = this.returnEasternTime()
            let switchTime = parseInt(defaultSwitchTime)
            // console.log('switch time', switchTime)
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime)
            }
            // console.log('new switch time', switchTime)
            // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                // console.log('event is today', switchTime)
                // console.log('time in event', this.getMinutesBetweenDates(currentDate, eventDate))
                // console.log('condition 1 status', this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime)
                // console.log('condition 2 status', this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0)
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
                    // console.log('true for event starting at', evtDate)
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
            // let eventDate = new Date(evtDate)
            // let eventEndDate = new Date(endDate)
            // let currentDate = this.returnEasternTime()
            // let switchTime = parseInt(defaultSwitchTime)
            // if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
            //     switchTime = parseInt(eventSwtichTime)
            // }
            // // console.log('time left', this.getMinutesBetweenDates(currentDate, eventDate))
            // if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
            //     if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime && this.getMinutesBetweenDates(currentDate, eventEndDate) >= 0) {
            //         return true
            //     } else {
            //         return false
            //     }
            // } else {
            //     return false
            // }
        },
        getDateReference (dte, type) {
            let dt = new Date(dte)
            let dayStr, monStr
            let eDay = dt.getDate()
            let eHours = this.getHoursFormatted(dt)
            let eMonth = dt.getMonth() + 1
            let day
            // Set Day of Date
            if (dt.getDay() === 0) {
                day = 'Sunday'
            } else if (dt.getDay() === 1) {
                day = 'Monday'
            } else if (dt.getDay() === 2) {
                day = 'Tuesday'
            } else if (dt.getDay() === 3) {
                day = 'Wednesday'
            } else if (dt.getDay() === 4) {
                day = 'Thursday'
            } else if (dt.getDay() === 5) {
                day = 'Friday'
            } else if (dt.getDay() === 6) {
                day = 'Saturday'
            } else {
                day = ''
            }
            // Set Date Pattern
            if (eDay === 1) {
                dayStr = '1st'
            } else if (eDay === 2) {
                dayStr = '2nd'
            } else if (eDay === 3) {
                dayStr = '3rd'
            } else if (eDay === 21) {
                dayStr = '21st'
            } else if (eDay === 22) {
                dayStr = '22nd'
            } else if (eDay === 23) {
                dayStr = '23rd'
            } else if (eDay === 31) {
                dayStr = '31st'
            } else {
                dayStr = eDay + 'th'
            }
            // Set Month
            if (eMonth === 1) {
                monStr = 'January'
            } else if (eMonth === 2) {
                monStr = 'February'
            } else if (eMonth === 3) {
                monStr = 'March'
            } else if (eMonth === 4) {
                monStr = 'April'
            } else if (eMonth === 5) {
                monStr = 'May'
            } else if (eMonth === 6) {
                monStr = 'June'
            } else if (eMonth === 7) {
                monStr = 'July'
            } else if (eMonth === 8) {
                monStr = 'August'
            } else if (eMonth === 9) {
                monStr = 'September'
            } else if (eMonth === 10) {
                monStr = 'October'
            } else if (eMonth === 11) {
                monStr = 'November'
            } else if (eMonth === 12) {
                monStr = 'December'
            }
            if (type === 'btn') {
                return 'Reserve your spot starting ' + monStr + ' ' + dayStr + '!'
            } else if (type === 'live') {
                return monStr + ' ' + eDay
            } else if (type === 'live2') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
            } else if (type === 'str') {
                return day + ', ' + monStr + ' ' + dayStr + ' at ' + eHours + ' ET'
            } else {
                return day + ', ' + monStr + ' ' + dayStr + ' @' + eHours + ' ET'
            }
        },
        returnEasternTime () {
            let offset = -5
            if (dateHelpers.dstEnabled(new Date())) {
                offset = -4.0
            }
            let clientDate = new Date()
            let utc = clientDate.getTime() + (clientDate.getTimezoneOffset() * 60000)
            let serverDate = new Date(utc + (3600000 * offset))
            return serverDate
        },
        showJoin (eventId) {
            let event = this.getCorpAllEvents.filter(evn => {
                return evn.eventId === eventId
            })
            if (this.isEventToday(event[0].start_date, event[0].end_date, event[0].eventSwitchTime, this.getEventSwitchTime)) {
                return true
            }
            return false
        },
        getHoursFormatted (time) {
            let hours = time.getHours()
            let minutes = time.getMinutes()
            let ampm = hours >= 12 ? 'pm' : 'am'
            hours = hours % 12
            hours = hours === 0 ? '12' : hours
            minutes = minutes < 10 ? '0' + minutes : minutes
            let strTime = hours + ':' + minutes + ' ' + ampm
            return strTime
        },
        switchTab: function (id) {
            this.selectedTab = id
            for (let tab in this.tabs) {
                this.tabs[tab] = id === tab
            }
        },
        redirectToSignUp () {
            if (this.getMarketingPlan) {
                this.$router.push('/signup/' + this.getMarketingPlan)
            } else {
                this.$router.push('/signup')
            }
        },
        initiateSearch () {
            this.pageStart = 1
            this.pageEnd = 6
            if (this.contentToSearch.length !== 0) {
                this.enteredValue = this.contentToSearch
                this.isBlankField = false
                this.isEmptyResponse = false
                this.spinnerToggle()
                this.$store.dispatch('GETSEARCHRESULTS', this.contentToSearch).then(() => {
                    window.logEvents('Search Page', 'click', `Title Searched: ${this.contentToSearch}`)
                    if (this.getSearchResults['length'] !== 0) {
//                        console.log('results', this.getSearchResults['length'], this.getSearchResults)
                    } else {
                        this.isEmptyResponse = true
                    }
                    this.spinnerToggle()
                })
            } else {
                this.$swal({
                    title: 'Please type something, the input field seems to be blank.',
                    text: '',
                    type: 'question',
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(
                    function () {
                    },
                    // handling the promise rejection
                    function (dismiss) {
                        if (dismiss === 'timer') {
                        }
                    }
                )
               // this.isBlankField = true
            }
        },
        spinnerToggle () {
            this.spinner = !this.spinner
        },
        limitTo (arr) {
            return arr.slice(this.pageStart - 1, this.pageEnd)
        },
        getVideoStatus (videoObject) {
            if (this.getAuthUserVideos) {
                let mediaId = videoObject.mediaid
                let exists = this.getAuthUserVideos.filter(videoObject => {
                    return videoObject.videoCode === mediaId
                })
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        setVideoStatus (videoObject) {
            if (this.getAuthUserVideos) {
                let mediaId = videoObject.mediaid
                let exists = this.getAuthUserVideos.filter(videoObject => {
                    return videoObject.videoCode === mediaId
                })
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0'
                    } else {
                        exists[0].liked = '1'
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(() => {
                        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                    })
                } else {
                    let logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                    })
                }
            }
        },
        setPlaylistVideoStatus (video, playlist, currentStatus) {
            let self = this
            self.selectedVideo = video.mediaid
            self.selectedPlaylist = playlist.playlistId
            if (currentStatus) { // Video is unSelected
                let payload = {}
                payload.videoCode = video.mediaid
                payload.userPlaylistId = playlist.playlistId
                payload.userId = this.user.userId
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                    self.videoAdded = false
                    self.videoRemoved = true
                })
            } else { // Video is Selected
                let payload = {}
                payload.videoCode = video.mediaid
                payload.userId = this.user.userId
                payload.userPlaylistId = playlist.playlistId
                this.$store.dispatch('ADDVIDEOINPLAYLIST', {playlist: payload}).then(() => {
                    // this.charities = this.getAuthUserVideos
                    self.videoAdded = true
                    self.videoRemoved = false
                })
            }
            setTimeout(() => {
                self.videoAdded = false
                self.videoRemoved = false
            }, 1500)
        },
        verifyPlaylistExists () {
            if (this.getUserPlaylists) {
                let playlistsWithVideo = this.getUserPlaylists.filter(x => {
                    return x.userPlaylistVideos !== null
                })
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        verifyVideoExists (playlist, video) {
            let self = this
            if (this.getUserPlaylists) {
                let findPlaylist = this.getUserPlaylists.filter(x => {
                    return x.playlistId === playlist.playlistId
                })
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        let videos = findPlaylist[0].userPlaylistVideos.filter(x => {
                            return x.videoCode === video.mediaid
                        })
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true
                            return true
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        addNewPlayList () {
            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                let payload = {}
                payload.userId = this.user.userId
                payload.title = this.newPlaylistName
                this.$store.dispatch('CREATEPLAYLIST', {playlist: payload}).then(() => {
                    this.newPlaylistName = ''
                    // this.charities = this.getAuthUserVideos
                })
            }
        },
        showPlaylistMenu (videoCode) {
            // console.log(videoCode)
            $('#' + videoCode + ' + ul').toggleClass('hide')
        },
        hidePlaylistMenu (videoCode) {
            // console.log(videoCode)
            $('#' + videoCode + ' + ul').toggleClass('hide')
        },
        calculateTimeToStartEvent (evtDate, endDate, eventSwtichTime, defaultSwitchTime) {
            // let self = this
            let eventDate = new Date(evtDate)
            let currentDate = this.returnEasternTime()
            let switchTime = parseInt(defaultSwitchTime)
            if (eventSwtichTime && (eventSwtichTime !== null || eventSwtichTime !== undefined) && eventSwtichTime > 0) {
                switchTime = parseInt(eventSwtichTime)
            }
            console.log('time left in event', this.getMinutesBetweenDates(currentDate, eventDate))
            if (eventDate.getDate() === currentDate.getDate() && eventDate.getMonth() + 1 === currentDate.getMonth() + 1 && eventDate.getFullYear() === currentDate.getFullYear()) {
                if (this.getMinutesBetweenDates(currentDate, eventDate) <= switchTime) {
                    console.log('event joining enabled')
                } else {
                    // console.log('difference', self.getMinutesBetweenDates(currentDate, eventDate))
                    // console.log('switch time', switchTime)
                    // console.log('time left', self.getMinutesBetweenDates(currentDate, eventDate) - switchTime)
                    let timeToStart = this.getMinutesBetweenDates(currentDate, eventDate) - switchTime
                    if (timeToStart > 0 && timeToStart <= 90) {
                        console.log('view needs to be freshed after: ', timeToStart)
                        let timeToTrigger = parseInt(timeToStart * 60 * 1000)
                        // console.log('trigger in seconds', timeToTrigger)
                        setTimeout(() => {
                            if (this.$route.name === 'CorporateCommunity') {
                                window.location.reload()
                            }
                        }, timeToTrigger + 60)
                    }
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'error', 'user', 'getDefaultPlan', 'getAuthUserVideos', 'getUserPlaylists', 'getTrialDays', 'getCorpPrivateEvents', 'getCorpAllEvents', 'getCorpPublicEvents', 'getCorpMainEvent', 'getAllExperts', 'getCorpArchiveEvents', 'getCorpPlaylists', 'getCorporationPinnedMsgs', 'getCropUserSharedVideos', 'getCorporatePayload', 'getEventSwitchTime', 'getCorpPrivateVideos', 'getDemoEvent', 'getCorporateClientForDemo', 'getUnauthUserSignature'
        ])
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .mainbanner img {
        width: 100%;
        max-height: 60vh;
        object-fit: cover;
        object-position: center center;
    }

    .profileimageanddata {
        clear: both;
        max-width: 1170px;
        margin: auto;
    }

    .profileimage {
        float: left;
        width: 170px;
        height: 170px;
        border: 10px solid #fff;
        transform: translateY(-50%);
        box-shadow: 0px 0px 11px rgba(0,0,0,0.25);
    }

    .profileimage img {
        width: 150px;
        height: 150px;
        object-fit: cover;
        object-position:center center;
    }

    .textmatterholder {
        float: left;
        width: calc(100% - 170px);
        text-align: left;
        padding-left: 30px;
        padding-top: 20px;
    }
    .tabs ul {
        margin: 0 0;
        padding: 0;
        list-style: none;
        display:flex;
    }

    .tabs ul li {
        flex:1;
        text-align: center;
        float: left;
        padding: 20px;
        font-size: 21px;
        font-weight: 900;
        border-bottom:1px solid #333;
    }

    .tabs li.current{
        border-bottom:1px solid #f0617d;
    }

    li.current a {
        color: #f0617d;
    }

    li a {
        color: #333;
    }

    .tabs:after {
        content: "";
        display: table;
        clear: both;
        width: 100%;
    }
    .introparacard {
        padding-top: 30px;
        text-align: left;
    }

    .introparacard img {
        max-width: 100%;
    }

    .introparacard blockquote {
        text-align: center;
        border: 0 none transparent;
        padding: 0;
        margin: 20px 0 0;
        font-weight: 700;
        font-style: italic;
    }
    hr.redhr {
        border-color: #f0617d;
        max-width: 575px;
    }
    @media(max-width:767px){
        li a {
            font-size: 14px;
        }

        .textmatterholder {
            width: 100%;
            padding: 0 20px;
        }

        .profileimage {
            float: none;
            margin: auto;
            transform: translateY(-20px);
        }
    }
    .imgresponsive img {
        width: 100%;
        height: auto;
    }

    .large-text {
        font-size: 16px;
    }



    /* css for the video popup*/

    button#videoplayer_videoredirect {
        border-radius: 5px;
        font-weight: 700;
    }

    button#videoplayer_videostay {
        background: white;
        color: #44bda8;
        border: 1px solid #44bda8;
        white-space: normal;
        line-height: 1;
        padding: 6px;
        border-radius: 5px;
    }
    .watchVideoModal .modal-dialog .modal-body p {
        padding: 16px 60px 19px 60px;
    }
    .watchVideoModal.modal.zoom.in {
        z-index: 500000;
    }
    .sharesmallpink.watchVideoModal .modal-dialog  .watchVideoModalHeader {
        background: #f0617d;
        color: #fff;
        font-size: 25px;
        text-align: left;
        padding: 15px 25px;
        font-weight: 700;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body p{
        padding: 0;
        margin: 0 0 20px;
    }
    .row.sharefb {
        background: #eee;
        margin-left: 0;
        margin-right: 0;
    }

    .row.sharefb > div {
        padding: 5px;
        text-align: left;
    }

    .row.sharefb .col-sm-5 img {
        max-width: 100%;
    }
    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
        font-size: 14px;
        font-weight: 300;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h6 {
        text-transform: uppercase;
        font-size: 12px;
        margin: 10px 0 5px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb h4 {
        margin: 0 0 5px;
        font-weight:700;
    }
    .row.buttonsinpopup {
        padding-top: 20px;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
        background: #fff;
        color: #333;
        border: 1px solid #cacaca;
        width: 100%;
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body {
    }

    .sharesmallpink.watchVideoModal .modal-dialog .modal-body button.btn.btn-primary.btn-pink {
        background: #f0617d;
        width: 100%;
        margin: 0;
        border: 1px solid #f0617d;
    }
    .usernamenimg.text-left table {
        max-width: 100%;
        margin: 0 0 20px;
        width: 190px;
    }
    a.popupsharingoptionlink {
        display: block;
        color: #fff;
        text-decoration: none;
        max-width: 150px;
        font-size: 18px;
        font-weight: 700;
        padding-top: 15px;
        text-align: center;
    }

    a.popupsharingoptionlink i:before {
        color: #fff;
    }

    a.popupsharingoptionlink i.fa.fa-share-square-o {
        margin: 0;
        font-size: 20px;
        /* display: block; */
    }
    .strongselec{
        font-weight:700;
    }
    @media(max-width:475px){
        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.buttonsinpopup button.btn.btn-default {
            padding-left: 0;
            padding-right: 0;
        }
    }

    .showmobile{display:none;}
    @media(max-width:767px){
        .usernamenimg.text-left {
            display: none;
        }
        .showmobile{
            display: block;
        }
        .alert.alert-default {
            background: #eee;
        }

        .sharesmallpink.watchVideoModal .modal-dialog .modal-body .row.sharefb p {
            display: none;
        }
        .sharesmallpink.watchVideoModal .modal-dialog .watchVideoModalHeader .watchVideoArrow {
            top: 1px;
            right: -13px;
        }
        .row.sharefb {
            display: flex;
            align-items: center;
        }
        .pinksidebarmin{
            padding:0 !important;
            display: flex;
            flex-direction: column;
            flex-basis: auto;
            display: flex ;
            align-items: stretch ;
            justify-content: center;
        }

        .pinksidebarmin > * {
            padding: 6px 0 !important;
            margin: 0 !important;
            flex: 100;
            text-align:center;
        }
    }
    /* css for the video popup ends*/
    @media(min-width:768px) {
        .sliderimage {
            width: 100%;
            /* height: 200px;*/
            object-fit: cover;
            object-position: center;
        }
    }

    .row.video-row.plistisrow img {
        max-width: 80%;
    }

    .row.video-row.plistisrow .col-sm-6 {
        text-align: left;
    }

    .pinksidebarmin {
        float: right;
        width: 20%;
        background: #f0617d;
        text-align: center;
        padding: 20px;
    }

    .pinkbg {background: #f0617d;}

    .pinksidebarmin > * {
        font-size: 25px;
        color: #fff;
        cursor: pointer;
        margin:20px 0;
    }
    @media(min-width:768px){
        .row.video-row.plistisrow .pinkbg img {
            height: 205px;
            object-fit: cover;
        }
        .pinksidebarmin {
            display: flex;
            flex-direction: column;
            height: 205px;
            align-items: center;
            justify-content: space-around;
        }

        .pinksidebarmin > * {
            font-size: 25px;
            color: #fff;
            cursor: pointer;
            padding:0;
            margin:0;
        }

    }
    .col-sm-6.pltext {
        cursor: pointer;
        font-size: 16px;
    }


    .pltext h3 {
        text-decoration: underline;
    }

    .clearfix {
        clear: both;
    }

    .incaseumi {
        font-size: 18px;
    }

    .incaseumi img {
        width: 100%;
    }
    .borderedbox {
        border: 1px solid #ddd;
        padding: 15px;
        margin: 10px 0;
        font-size: 16px;
    }

    .pinnedmsgs {
        text-align: left;
    }

    .pinnedmsgs h3 {
        color: #f0617d;
    }
    .row.video-row.plistisrow .videoholdersuggestions img {
        width: 100%;
        max-width: none;
        cursor: pointer;
    }

    .videoholdersuggestions{
        margin:0 0 30px;
    }

    .videoholdersuggestions h3 {
        text-align: center;
        font-weight: 900;
        cursor: pointer;
    }

    .videoholdersuggestions p {
        font-size: 18px;
    }
    .row.video-row.plistisrow.lowerlist .col-sm-6:nth-of-type(odd) {
        clear: left;
    }

    .smallimgholder {text-align: center;padding: 10px;box-shadow: 0 0 5px rgba(0,0,0,0.5);}

    .smallimgholder img {
        height: auto;
        width: 100%;
    }
    @media(max-width:991px){
        .hidemobile {
            display: none;
        }

        .smallimgholder {
            max-width: 300px;
            margin: 0 auto;
        }
    }
    @media(max-width:991px){
        .tabs ul {
            display: flex;
            align-items: stretch;
            justify-items: stretch;
            justify-content: space-between;
        }
        .tabs ul li{
            width: auto;
            padding: 20px 0;
            flex: 1;
        }
        img.sliderimage {
            max-width: 100%;
        }
    }
    .row.yourFaves p.text-wrap-title.cursor {
        font-size: 16px;
        font-weight: 500;
        color: #000;
        text-align: left;
        line-height: 1.5;
    }
    .row.yourFaves {
        padding-top: 20px;
    }
    @media(min-width:992px) and (max-width:1200px){
        .tabs ul li {
            padding-right: 5px !important;
            padding-left: 5px !important;
        }
    }
    .m-auto {
        margin: auto;
        float: none;
    }
</style>



// WEBPACK FOOTER //
// CommunityDemo.vue?4d14f5ac